import { Component, OnInit } from '@angular/core';
import { PayloadService } from '@src/app/services/payload/payload.service';
import { ApolloService } from '@src/app/services/apollo/apollo.service';
import { firstValueFrom } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { ScopeService } from '@src/app/services/scope/scope.service';
import { Retailer } from '@src/app/model/retailer';
import { Id } from '@ess/jg-rule-executor';
import { LoginService } from '@src/app/services/login/login.service';
import { RetailerScope } from '@src/app/model/retailer-scope';

@Component({
  selector: 'app-payload',
  templateUrl: './payload.component.html',
  styleUrls: ['./payload.component.css'],
  standalone: false,
})
export class PayloadComponent implements OnInit {
  public templateText: string = 'the payload is loading...';

  private _scope: Id<Retailer>;
  private _code: string;
  private _retailerKey: string;

  constructor(
    private _apolloService: ApolloService,
    private _payloadService: PayloadService,
    private route: ActivatedRoute,
    private _scopeService: ScopeService,
    private _loginService: LoginService
  ) {

  }

  async ngOnInit(): Promise<void> {
    const params = await firstValueFrom(this.route.queryParams);
    this._code = params['code'];
    this._scope = params['scope'];
    this._retailerKey = params['key'];

    // Interceptor will bypass if key is defined
    this._loginService.retailerKey = this._retailerKey;

    if (this._scope && this._code && this._retailerKey) {
      this._scopeService.setScope(new RetailerScope(this._scope, 'dummy'));
      const configuration = await firstValueFrom(this._apolloService.getConfigurationByCode$(this._code));

      if (configuration) {
        const payloadStr = await this._payloadService.getPayloadString(
          configuration,
          this._scope.toString(),
          this._retailerKey
        );
        const payloadBlob = new Blob([payloadStr], { type: 'application/json' });
        this.navigateTo(payloadBlob);
      }
    }
  }

  public navigateTo(payload: Blob): void {
    window.location.href = window.URL.createObjectURL(payload);
  }
}
